import { FC } from 'react';
import { Blue100, Button, ButtonIcon, Gray170, TextInput, typeCompact12MediumProperties } from '@traceair/tds';
import { MinusIcon, PlusIcon } from '@traceair/webapp-icons';
import { classes, style, stylesheet } from 'typestyle';
import { sharedInvoicingCss } from '../styles/shared';

const st = stylesheet({
  body: {
    padding: '0 16px 12px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  addItemRow: {
    paddingLeft: 32,
  },
  addItemBtn: {
    ...typeCompact12MediumProperties,
  },
});

export type OtherItem = { id: string; label: string; price: string };

type Props = {
  items: OtherItem[];
  onRemove: (id: string) => void;
  onLabelChange: (id: string, value: string) => void;
  onPriceChange: (id: string, value: string) => void;
  onAdd: () => void;
  isLabelError?: (item: OtherItem) => boolean;
};

const css = sharedInvoicingCss;

export const OtherItemsList: FC<Props> = ({ items, onRemove, onLabelChange, onPriceChange, onAdd, isLabelError }) => (
  <div className={st.body}>
    {items.map((item) => (
      <div key={item.id} className={css.otherInputRow}>
        <ButtonIcon
          icon={<MinusIcon color={Gray170} />}
          style="tertiary"
          size="xs"
          className={css.removeItemBtn}
          onClick={() => onRemove(item.id)}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <TextInput
            value={item.label}
            placeholder="Item"
            isError={isLabelError ? isLabelError(item) : false}
            onChange={(value) => onLabelChange(item.id, value)}
          />
        </div>
        <div className={classes(css.priceInputContainer, style({ maxWidth: 90, flexGrow: 0 }))}>
          <TextInput
            leftCell={item.price ? '$' : undefined}
            value={item.price}
            placeholder="Price"
            onChange={(value) => onPriceChange(item.id, value)}
          />
        </div>
      </div>
    ))}
    <div className={st.addItemRow}>
      <Button
        style="secondary"
        size="xs"
        icon={<PlusIcon size={14} color={Blue100} />}
        text="Add item"
        className={st.addItemBtn}
        onClick={onAdd}
      />
    </div>
  </div>
);
